
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 64 64","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M50.7 42.4c-.6-1.4-1.7-2.5-3.1-3.1.8-.1 1.7-.2 2.5-.2.3-.1.6-.1.8-.3-.1-.3-.1-.7-.3-.9-.7-.6-1.5-1.1-2.3-1.5-1.1-.3-2.2-.6-3.3-.8-.1-.7-.1-1.6-.2-2.4-.4-2.8-1.5-5.5-3.1-7.8-.4-.5-.9-1-1.4-1.3-1-.5-1-.8-2.1-1.4-.2-.1-.4-.4-.6-.6l.1-.2c1.2.6 2.6.8 4 .7.6 0 1-.2 1-.8v-3.3c-.1-.3-.2-.6-.5-.7-1.7-.2-3.3-.3-4.7.9-.6.5-1.3.9-2.1 1l-3.3.9c-.5.1-.8.5-.7 1 0 .1 0 .2.1.3.2.5.7.8 1.2.6.4-.1.8-.3 1.1-.5.6-.3 1.2-.7 1.8-1 .1.2.2.4.3.5 1.3 3.2 2.2 6.6 2.6 10 .1.4.1.9-.1 1.3-.8 2-2.4 3.7-4.5 4.5-2.3.7-4.8.8-7.1.5-1.4-.1-1.7-.7-1.2-2 .3-.9.8-1.8 1.1-2.6.3-.4.4-.9.3-1.4.8-.2 1.3-.8 1.3-1.6 0-.9-.8-1.7-1.7-1.6H16.8c-.9-.1-1.7.6-1.8 1.5v.2c0 .3.1.6.2.8-.4.1-.7.3-.9.6-1.2 1.5-2.2 3.2-2.8 5.1-.5 1.8-.1 2.7 1.5 3.7l1 .6c-1.5 1.9-1.5 4.6 0 6.4 1.3 1.7 3.6 2.3 5.6 1.4 2.7-1.1 3.5-3.3 2.9-6.1h.3c3.6.1 7.3.2 10.9.4.9 0 1.7-.3 2.4-.8.6-.4 1.2-.8 1.9-1.3-.1.7-.1 1.3 0 2 .1.4.3 1 .6 1.1s.8-.3 1.1-.6c.4-.4.8-.9 1.2-1.4-.4 1.3-.3 2.8.2 4.1.5 1.3 1.6 2.4 3 2.8 2.2.8 4.6 0 5.9-2 1.1-1.6 1.2-3.2.7-4.7zm-30.9 3.4c-.9 1-2.4 1.2-3.5.3-.9-.7-1.1-2-.6-3 .3-.8 1.2-1.3 2.1-1l-.8 1.2c-.5.6-.4 1.4.1 1.9l.1.1c.6.4 1.4.2 1.8-.3 0-.1.1-.1.1-.2.3-.5.6-.9.9-1.4.6.7.5 1.7-.2 2.4zm28 .2c-.8.8-2 .9-3 .4-1-.6-1.4-1.8-1-2.9.5.5.8 1 1.2 1.5.4.5 1.2.6 1.8.2.5-.4.6-1.2.2-1.8-.3-.4-.7-.9-1-1.3V42c.9-.2 1.9.3 2.3 1.1.5.9.3 2.1-.5 2.9z"}})])
          )
        }
      }
    